// Global store for EightDInfoId
let globalEightDInfoId = 0;

export const setEightDInfoId = (id) => {
  globalEightDInfoId = id;
};

export const getEightDInfoId = () => {
  return globalEightDInfoId;
};
